import { useTranslation } from "react-i18next";
import { Typography, Button, Box } from "@mui/material";
import React from "react";
import { Fragment } from "react";
import { useNavigate, useLocation } from "react-router-dom";
// import * as Sentry from "@sentry/react";
import apiRequest from "../../functions/api";
import { DEBUG_FLAG } from "../../constants/debug";
import { VERSION } from "../../constants/version";
import { LOCAL_STORAGE_KEY } from "../../constants/localStorage";
import { useSessionStorage } from "../../utils/hooks";
import { osName, osVersion } from "react-device-detect";

const ErrorBoundaryWithNavigate = ({ children, ...props }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [accessToken] = useSessionStorage(LOCAL_STORAGE_KEY.accessToken);

  const { t } = useTranslation();
  return (
    <ErrorBoundary navigate={navigate} location={location} accessToken={accessToken} t={t} {...props}>
      {children}
    </ErrorBoundary>
  );
};
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      redirectTo: null,
      mounted: false,
      error: null,
      version: localStorage.getItem(LOCAL_STORAGE_KEY.version) || VERSION,
      client: localStorage.getItem(LOCAL_STORAGE_KEY.client),
    };
  }

  componentDidMount() {
    this.setState({ mounted: true });
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error: error };
  }

  componentDidCatch(error, info) {
    // You can also log the error to an error reporting service
    console.log(error);
    this.logErrorToMyService(error, info);
  }
  errorCb = (response) => {
    if (response.status === 200) {
      console.log("successfully sent error log");
    } else {
      console.log("failed to send error log");
    }
  };

  setRedirect = (path) => {
    const { navigate } = this.props;
    this.setState({ hasError: false, error: null });
    if (navigate) navigate(path);
  };

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <Fragment>
          {osName === "Android" && Number(osVersion) >= 15 ? <div className="ectool-safe-area-top"></div> : <div className="ectool-safe-area-top"></div>}
          <Box p={2}>
            <Box p={1}>
              <Typography variant="h4" color="error">
                {this.props.t("Unerwarteter Fehler")}
              </Typography>
            </Box>
            <Box p={1}>
              <Typography variant="body1">{this.props.t("Es ist ein Fehler aufgetreten. Dieser wurde automatisch an ectool übermittelt.")}</Typography>
            </Box>
            <Box p={1}>
              <Button variant="contained" color="primary" onClick={() => this.setRedirect("/")}>
                {this.props.t("Zum Verteiler")}
              </Button>
            </Box>
          </Box>
        </Fragment>
      );
    }
    return this.props.children;
  }
  logErrorToMyService(error, info) {
    //Sentry.captureException(error);
    if (!DEBUG_FLAG()) {
      const payload = {
        mandant: this.state.client,
        error: error.toString(),
        program: this.props.location.pathname,
        component: this.props.errorComponent,
        version: this.state.version,
        build: VERSION,
        errorInfo: info.componentStack,
      };
      var headers = {};
      if (this.props.accessToken !== "") {
        headers = {
          Authorization: "Bearer " + this.props.accessToken,
        };
      }
      apiRequest("POST", "error", payload, headers, this.errorCb);
    }
  }
}
export default ErrorBoundaryWithNavigate;
